"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var get_1 = __importDefault(require("lodash/get"));
var groupBy_1 = __importDefault(require("lodash/groupBy"));
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var FooterCell_1 = __importDefault(require("atomicComponents/molecules/Table/FooterCell"));
var StickyRow_1 = __importDefault(require("atomicComponents/molecules/Table/TableRows/StickyRow"));
var Money_1 = __importDefault(require("components/Money"));
var utils_1 = require("./utils");
var valueIsNumOrStr = function (v) { return ['number', 'string'].includes(typeof v) || !v; };
var valueIsNum = function (v) { return typeof v === 'number' || !v; };
var makeFooter = function (tableConf) {
    var processedTableConf = (0, utils_1.applyTableConfDefaults)(tableConf);
    var FooterComponent = function (_a) {
        var _b, _c;
        var items = _a.items, isPartialView = _a.isPartialView, props = __rest(_a, ["items", "isPartialView"]);
        var theme = (0, material_1.useTheme)();
        var isLargeScreen = (0, material_1.useMediaQuery)(theme.breakpoints.up('md'));
        var footerSelected = (0, react_redux_1.useSelector)((_c = (_b = processedTableConf.footer) === null || _b === void 0 ? void 0 : _b.footerSelector) !== null && _c !== void 0 ? _c : (function () { return undefined; }));
        var totals = react_1.default.useMemo(function () {
            var totalsIn = {};
            processedTableConf.cells.filter(function (cC) { return cC.footerAggregate; }).forEach(function (cellConf) {
                var field = cellConf.field, fields = cellConf.fields, footerAggregateValueExtract = cellConf.footerAggregateValueExtract;
                var extractor = function (item) { return mainField && (0, utils_1.getValue)(item, mainField, processedTableConf.extractors); };
                var mainField = field !== null && field !== void 0 ? field : fields === null || fields === void 0 ? void 0 : fields[0];
                if (mainField) {
                    if (cellConf.footerAggregate === 'sum') {
                        items.forEach(function (item) {
                            var value = footerAggregateValueExtract
                                ? footerAggregateValueExtract(item, footerSelected)
                                : (0, utils_1.getValue)(item, mainField !== null && mainField !== void 0 ? mainField : fields === null || fields === void 0 ? void 0 : fields[0], processedTableConf.extractors) || 0;
                            var valueToAdd = Array.isArray(value) ? value.length : +value;
                            if (!Number.isNaN(valueToAdd)) {
                                totalsIn[mainField] = (totalsIn[mainField] || 0) + valueToAdd;
                            }
                        });
                    }
                    if (cellConf.footerAggregate === 'count') {
                        totalsIn[mainField] = items.length;
                    }
                    if (cellConf.footerAggregate === 'countNonEmpty') {
                        totalsIn[mainField] = items.filter(extractor).length;
                    }
                    if (cellConf.footerAggregate === 'countUniq') {
                        totalsIn[mainField] = new Set(items.map(function (item) { return (0, get_1.default)(item, mainField); }).filter(Boolean)).size;
                    }
                    if (cellConf.footerAggregate === 'countGroups') {
                        totalsIn[mainField] = (0, mapValues_1.default)((0, groupBy_1.default)(items, mainField), 'length');
                    }
                    if (cellConf.footerAggregate === 'min-max') {
                        var values = items.map(extractor).map(function (v) { return v !== null && v !== void 0 ? v : 0; });
                        var min = Math.round(Math.min.apply(Math, __spreadArray([], __read(values), false)));
                        var max = Math.round(Math.max.apply(Math, __spreadArray([], __read(values), false)));
                        totalsIn[mainField] = max !== min ? "".concat(min, "-").concat(max) : max;
                    }
                }
            });
            return totalsIn;
        }, [items]);
        return ((0, jsx_runtime_1.jsxs)(StickyRow_1.default, __assign({ bottom: 0, pl: 2, pr: isLargeScreen ? 9.375 : 0, mx: -2, width: 1 }, props, { children: [processedTableConf.cells.map(function (cellConf, idx) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                    var RenderComponent = cellConf.footerAggregateRenderValue;
                    var RenderObjComponent = cellConf.footerAggregateRenderObj;
                    var mainField = (_a = cellConf.field) !== null && _a !== void 0 ? _a : (_b = cellConf.fields) === null || _b === void 0 ? void 0 : _b[0];
                    var value = mainField ? totals === null || totals === void 0 ? void 0 : totals[mainField] : undefined;
                    var leftPosition = 0;
                    var fixCell = ((_c = processedTableConf === null || processedTableConf === void 0 ? void 0 : processedTableConf.layout) === null || _c === void 0 ? void 0 : _c.fixedColumns) ? idx <= (processedTableConf.layout.fixedColumns - 1) : false;
                    var moneyCellProps = cellConf.money || ((_e = (_d = tableConf.fieldOverrides) === null || _d === void 0 ? void 0 : _d[mainField]) === null || _e === void 0 ? void 0 : _e.money);
                    if (fixCell) {
                        leftPosition = (0, sumBy_1.default)(processedTableConf.cells.slice(0, idx), 'cell.width');
                    }
                    return ((0, jsx_runtime_1.jsx)(FooterCell_1.default, __assign({ flex: "none", textAlign: cellConf.money ? 'right' : 'left', pl: !((_f = cellConf.cell) === null || _f === void 0 ? void 0 : _f.textAlign) ? 0 : 1, hidden: cellConf.hiddenOnPartial && isPartialView, hasGutter: true, left: fixCell ? leftPosition : undefined, stopPropagation: !!cellConf.stopPropagation }, cellConf.cell, { sx: __assign({}, (_g = processedTableConf.footer) === null || _g === void 0 ? void 0 : _g.cellProps), zIndex: fixCell ? 2 : undefined }, { children: mainField && cellConf.footerAggregate
                            && ((RenderComponent && (valueIsNumOrStr(value)) && (0, jsx_runtime_1.jsx)(RenderComponent, { value: value !== null && value !== void 0 ? value : 0 }))
                                || (RenderObjComponent && typeof value === 'object' && (0, jsx_runtime_1.jsx)(RenderObjComponent, { value: value }))
                                || ((_h = cellConf.renderField) === null || _h === void 0 ? void 0 : _h.call(cellConf, value))
                                || (value && ['number', 'string'].includes(typeof value) && '')
                                || (moneyCellProps && valueIsNum(value) && (0, jsx_runtime_1.jsx)(Money_1.default, __assign({ amount: value || 0 }, moneyCellProps)))
                                || value) }), (_l = (_j = cellConf.field) !== null && _j !== void 0 ? _j : (_k = cellConf.fields) === null || _k === void 0 ? void 0 : _k.join()) !== null && _l !== void 0 ? _l : cellConf.key));
                }), (0, jsx_runtime_1.jsx)("div", { style: { width: 8 } })] })));
    };
    return react_1.default.memo(FooterComponent);
};
exports.default = makeFooter;
